export const GET_ADMIN_PROFILE_OPERATOR_DETAIL_START =
  "GET_ADMIN_PROFILE_OPERATOR_DETAIL_START";
export const GET_ADMIN_PROFILE_OPERATOR_DETAIL_ERROR =
  "GET_ADMIN_PROFILE_OPERATOR_DETAIL_ERROR";
export const GET_ADMIN_PROFILE_OPERATOR_DETAIL_SUCCESS =
  "GET_ADMIN_PROFILE_OPERATOR_DETAIL_SUCCESS";